import React from 'react';
import { format } from 'date-fns';
import { getText } from '@storebrand-digital/fms-translations';

import { useAppDispatch, useAppSelector } from '../../app/store';
import { filterActions } from './reducer';
import FilterChip from './Filter.Chip';

const DATE_DISPLAY_FORMAT = 'dd.MM.yyyy';
const DATE_VALUE_FORMAT = 'yyyy-MM-dd';

function DateChips() {
  const dispatch = useAppDispatch();
  const createdFrom = useAppSelector((state) => state.filter.createdFrom);
  const createdTo = useAppSelector((state) => state.filter.createdTo);

  if (!createdFrom && !createdTo) {
    return null;
  }

  return (
    <div className="chips-date-row">
      {createdFrom && (
        <FilterChip
          id="period-from"
          name="createdFrom"
          label={`${getText('fromDate')}: ${format(createdFrom, DATE_DISPLAY_FORMAT)}`}
          value={format(createdFrom, DATE_VALUE_FORMAT)}
          trackId="button-remove_from_date|Fra dato"
          onRemove={() => dispatch(filterActions.deselectCreatedFrom())}
        />
      )}
      {createdTo && (
        <FilterChip
          id="period-to"
          name="createdTo"
          label={`${getText('toDate')}: ${format(createdTo, DATE_DISPLAY_FORMAT)}`}
          value={format(createdTo, DATE_VALUE_FORMAT)}
          trackId="button-remove_to_date|Til dato"
          onRemove={() => dispatch(filterActions.deselectCreatedTo())}
        />
      )}
    </div>
  );
}

export default DateChips;
